import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { imageUrl } from '../lib/api'

// Read-only thumbnail grid for stored images (idea detail / comments / admin edit).
// Clicking a thumbnail opens a dismissable lightbox instead of a new browser tab.
export function RoadmapGallery({ images }: { images?: { url: string }[] }) {
    const [zoom, setZoom] = useState<string | null>(null)
    if (!images || images.length === 0) return null
    return (
        <>
            <div className="roadmap-gallery">
                {images.map((img, i) => (
                    <button
                        key={i}
                        type="button"
                        className="roadmap-gallery-item"
                        onClick={() => setZoom(imageUrl(img.url))}
                        title="Click to enlarge"
                    >
                        <img src={imageUrl(img.url)} alt="" loading="lazy" />
                    </button>
                ))}
            </div>
            {zoom && <ImageLightbox src={zoom} onClose={() => setZoom(null)} />}
        </>
    )
}

// Info-only overlay: dismissable via the backdrop, the ✕ button, or the Escape key.
export function ImageLightbox({ src, onClose }: { src: string; onClose: () => void }) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        const prevOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => {
            document.removeEventListener('keydown', onKey)
            document.body.style.overflow = prevOverflow
        }
    }, [onClose])

    return createPortal(
        <div className="roadmap-lightbox" onClick={onClose} role="dialog" aria-modal="true">
            <button className="roadmap-lightbox-close" onClick={onClose} aria-label="Close">✕</button>
            <img
                src={src}
                alt=""
                className="roadmap-lightbox-img"
                onClick={e => e.stopPropagation()}
            />
        </div>,
        document.body,
    )
}
